import type { ChatType } from "@circle-react/types/CommunityBot/ChatSort";
import { Select } from "@circleco/compass/components/Select";

import { t } from "@/i18n-js/instance";

import { CHAT_TYPES } from "../constants";

interface ChatTypesDropdownComponentProps {
  activeItem: ChatType;
  dataTestId?: string;
  localeScope: string;
  onItemClick: (item: ChatType) => void;
}

export const ChatTypesDropdownComponent = ({
  activeItem,
  dataTestId,
  localeScope,
  onItemClick,
}: ChatTypesDropdownComponentProps) => {
  const options = [
    {
      value: CHAT_TYPES.ALL,
      label: t([localeScope, CHAT_TYPES.ALL]),
    },
    {
      value: CHAT_TYPES.UNREAD,
      label: t([localeScope, CHAT_TYPES.UNREAD]),
    },
    {
      value: CHAT_TYPES.AI_PAUSED,
      label: t([localeScope, CHAT_TYPES.AI_PAUSED]),
    },
  ];

  const selectedOption = options.find(opt => opt.value === activeItem);

  return (
    <Select<ChatType>
      options={options}
      value={selectedOption}
      align="start"
      side="bottom"
      data-testid={dataTestId}
      onValueChange={opt => {
        if (opt) onItemClick(opt.value);
      }}
    />
  );
};
